module.exports = __webpack_public_path__ + "img/E8DEE1_B5A6AA_CCBCC1_C4BBBC-256px.cbe65b05.png";